import { render, staticRenderFns } from "./FlatDetail.vue?vue&type=template&id=54fefc0d&scoped=true"
import script from "./FlatDetail.vue?vue&type=script&lang=js"
export * from "./FlatDetail.vue?vue&type=script&lang=js"
import style0 from "./FlatDetail.vue?vue&type=style&index=0&id=54fefc0d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fefc0d",
  null
  
)

export default component.exports